import { render, staticRenderFns } from "./sideFixed.edit.vue?vue&type=template&id=6d797f4c&scoped=true"
import script from "./sideFixed.edit.vue?vue&type=script&lang=js"
export * from "./sideFixed.edit.vue?vue&type=script&lang=js"
import style0 from "./sideFixed.edit.vue?vue&type=style&index=0&id=6d797f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d797f4c",
  null
  
)

export default component.exports